export const tagsTableHeader = [
  {
    name: "Tag Name",
    field: "name",
    align: "left",
    sorting: false,
  },
  {
    name: "Contacts",
    field: "contacts",
    align: "left",
    sorting: false,
  },
  {
    name: "Created On",
    field: "createdOn",
    align: "left",
    sorting: false,
  },
  {
    name: "Updated On",
    field: "updatedOn",
    align: "left",
    sorting: false,
  },
  {
    name: "Action",
    field: "action",
    align: "right",
    sorting: false,
    hide: true
  },
];

export const contactTagTableHeader = [
  {
    name: "Email",
    field: "emailId",
    align: "left",
    sorting: false,
  },
  {
    name: "Name",
    field: "name",
    align: "left",
    sorting: false,
  },
  {
    name: "Status",
    field: "status",
    align: "left",
    sorting: false,
  },
  {
    name: "Created on",
    field: "createdOn",
    align: "left",
    sorting: false,
  },
  {
    name: "Action",
    field: "remove",
    align: "center",
    sorting: false,
    hide: true
  },
];
